module.exports = __webpack_public_path__ + "static/media/29.cc34d03a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/29.png
// module id = 396
// module chunks = 0